import script from "./GiveProductsToTechnicianModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GiveProductsToTechnicianModal.vue?vue&type=script&setup=true&lang=js"

import "./GiveProductsToTechnicianModal.vue?vue&type=style&index=0&id=20da0fb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20da0fb6"]])

export default __exports__